import React from 'react'

import { useIntl } from 'react-intl'

import UINames from 'constants/ui-names'

import { useDisplayManager } from 'components/DisplayManager'

import Locale from './locale'
import Styles from './styles.scss'

const DOCUMENTATION_URL = 'https://support.termly.io/hc/en-us/articles/43111540204689'
const FOCUS_ID = 'floating-preferences-button'


export default function FloatingPreferencesButton() {
  const { formatMessage } = useIntl()
  const { pushActiveUI } = useDisplayManager()

  const onClick = (e) => {
    e.stopPropagation()

    pushActiveUI(UINames.PREFERENCES)
  }

  const className = `${ Styles.root } termly-floating-preferences`
  const ariaLabel = formatMessage(Locale.cookiePreferences)
  const documentation = formatMessage(Locale.documentation, {
    url: DOCUMENTATION_URL,
  })

  // N.B.: we're expecting the button to have a background applied via CSS
  // so that site owners can customize the look of the button without any
  // code changes.
  return (
    <button
      aria-haspopup="dialog"
      aria-label={ ariaLabel }
      className={ className }
      data-documentation={ documentation }
      data-focus-id={ FOCUS_ID }
      onClick={ onClick }
      title={ ariaLabel }
      type="button"
    />
  )
}
